'use client';

import { useEffect } from 'react';
import { useSystemSettings } from '../contexts/SystemSettingsContext';

const DynamicFavicon = () => {
  const { settings } = useSystemSettings();

  useEffect(() => {
    if (!settings?.faviconUrl) return;

    let link = document.querySelector("link[rel='icon']");

    // If favicon link doesn't exist, create it
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }

    link.href = settings.faviconUrl.startsWith('http')
      ? settings.faviconUrl
      : `${process.env.NEXT_PUBLIC_IMAGE_URL}${settings.faviconUrl}`;
  }, [settings?.faviconUrl]);

  return null;
};

export default DynamicFavicon;
